import React from 'react'

function Propertyarea() {
  return (
    <div>
{/* <!-- Start Properties Wrap Area --> */}
<div className='pro_container'>
    <div class="properties-wrap-area pt-120 pb-95 mt-20">
        
        <div class="container-fluid">
            <div class="row" data-cues="slideInUp">
                <div class="col-12 col-md-8">
                    <h2><b>Explore Our Ongoing Projects</b></h2>
                </div>  
                <div>
                <div>
                    <div class="properties-wrap-tabs">
                        {/* <ul class="nav nav-tabs" id="properties_wrap_tab" role="tablist" data-cue="slideInUp">
                            <li class="nav-item"><a class="nav-link active" id="houses-tab" data-bs-toggle="tab" href="#houses" role="tab" aria-controls="houses">All</a></li>
                            <li class="nav-item"><a class="nav-link" id="villas-tab" data-bs-toggle="tab" href="#farmhouse" role="tab" aria-controls="farmhouse">Farmhouse</a></li>
                            <li class="nav-item"><a class="nav-link" id="rental-tab" data-bs-toggle="tab" href="#Commerical" role="tab" aria-controls="Commerical">Commerical</a></li>
                            
                        </ul> */}
                    </div>
                    </div>
                </div>
            </div>
            {/* <!-- properties cards start --> */}
            
            <div class="tab-content" id="properties_tab_wrap_content">
                <div class="tab-pane fade show active" id="houses" role="tabpanel">
                    <div class="row justify-content-center" data-cues="slideInUp">
                        
                        <div class="col-xl-6 col-md-12">
                            <div class="properties-inner-card">
                                <div class="row justify-content-center">
                                    <div class="col-lg-5 col-md-6">
                                      <a href="shanti-farms.html">
                                      <div class="properties-image bg-two"> 
                                            
                                            <div class="media">
                                                <span><i class="ri-vidicon-fill"></i></span>
                                                <span><i class="ri-image-line"></i>5</span>
                                            </div> 
                                        </div> 
                                        </a>
                                    </div>
                                    <div class="col-lg-7 col-md-6">
                                        <div class="properties-content">
                                            <div class="info">
                                                <ul class="link-list">
                                                    <li>
                                                        <span class="link-btn">Farm Houses</span>
                                                    </li>
                                                    <li>
                                                        <span class="link-btn">For Sale</span>
                                                    </li>
                                                </ul>
                                                
                                            </div>
                                            <div class="title">
                                                <h3>
                                                    <a href="/ongoing_project">मेरी बेटी मेरा गौरव अभियान</a>
                                                </h3>
                                                <span>JODHPUR, NAGAUR</span>
                                            </div>
                                            <ul class="info-list">
                                                <li>
                                                    <div class="icon">
                                                        <img src="/img/road-solid.svg" alt="Roads"/>
                                                    </div>
                                                    <span>60 ft Road</span>
                                                </li>
                                                <li>
                                                    <div class="icon">
                                                        <img src="/img/dungeon-solid.svg" alt="Roads"/>
                                                    </div>
                                                    <span>Gated Township</span>
                                                </li>
                                                <li>
                                                    <div class="icon">
                                                        <img src="/img/tree-solid.svg" alt="Roads"/>
                                                    </div>
                                                    <span>Green Area</span>
                                                </li>
                                                
                                            </ul>
                                            <div class="price-and-user">
                                                <p>Pricing per sq yrd <br/><span class="price"></span></p>
                                                <a href="contact-us.html"><div class="default-btn-black-secondary">In   ire Now</div></a>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-md-12">
                            <div class="properties-inner-card">
                                <div class="row justify-content-center">
                                    <div class="col-lg-5 col-md-6">
                                        <a href="">
                                        <div class="properties-image bg-three ">
                                            
                                            <div class="media">
                                                <span><i class="ri-vidicon-fill"></i></span>
                                                {/* <span><i class="ri-image-line"></i>5</span> */}
                                            </div>
                                        </div>
                                        </a>
                                    </div>
                                    <div class="col-lg-7 col-md-6">
                                        <div class="properties-content">
                                            <div class="info">
                                                <ul class="link-list">
                                                    <li>
                                                        <span class="link-btn">  Gateway Landmark GroupFarms </span>
                                                    </li>
                                                    <li>
                                                        <span class="link-btn">For Sale</span>
                                                    </li>
                                                </ul>
                                                
                                            </div>
                                            <div class="title">
                                                <h3>
                                                    <a href="">  मेरी बेटी मेरा गौरव अभियान </a>
                                                </h3>
                                                <span>JODHPUR, NAGAUR</span>
                                            </div>
                                            <ul class="info-list">
                                                <li>
                                                    <div class="icon">
                                                        <img src="/img/road-solid.svg" alt="Roads"/>
                                                    </div>
                                                    <span>120 ft Road</span>
                                                </li>
                                                <li>
                                                    <div class="icon">
                                                        <img src="/img/dungeon-solid.svg" alt="Roads"/>
                                                    </div>
                                                    <span>Prime Location</span>
                                                </li>
                                                <li>
                                                    <div class="icon">
                                                        <img src="/img/tree-solid.svg" alt="Roads"/>
                                                    </div>
                                                    <span>JDA Approved</span>
                                                </li>
                                                
                                            </ul>
                                            <div class="price-and-user">
                                                <p>Pricing  <br/><span class="price"></span></p>
                                                {/* <a href="contact-us.html"><div class="default-btn-black-secondary">Inquire Now</div></a> */}
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="tab-pane fade" id="farmhouse" role="tabpanel">
                    <div class="row justify-content-center" data-cue="slideInUp">
                        <div class="col-xl-6 col-md-12">
                            <div class="properties-inner-card">
                                <div class="row justify-content-center">
                                    <div class="col-lg-5 col-md-6">
                                        <div class="properties-image bg-two">
                                            
                                            <div class="media">
                                                <span><i class="ri-vidicon-fill"></i></span>
                                                {/* <span><i class="ri-image-line"></i>5</span> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-7 col-md-6">
                                        <div class="properties-content">
                                            <div class="info">
                                                <ul class="link-list">
                                                    <li>
                                                        <span class="link-btn">Farm Houses</span>
                                                    </li>
                                                    <li>
                                                        <span class="link-btn">For Sale</span>
                                                    </li>
                                                </ul>
                                                
                                            </div>
                                            <div class="title">
                                            <h3>
                                                    <a href="/ongoing_project">मेरी बेटी मेरा गौरव अभियान</a>
                                                </h3>
                                                <span>JODHPUR, NAGAUR</span>
                                            </div>
                                            <ul class="info-list">
                                                <li>
                                                    <div class="icon">
                                                        <img src="assets/images/properties/road-solid.svg" alt="Roads"/>
                                                    </div>
                                                    <span>60 ft Road</span>
                                                </li>
                                                <li>
                                                    <div class="icon">
                                                        <img src="assets/images/properties/dungeon-solid.svg" alt="Roads"/>
                                                    </div>
                                                    <span>Gated Township</span>
                                                </li>
                                                <li>
                                                    <div class="icon">
                                                        <img src="assets/images/properties/tree-solid.svg" alt="Roads"/>
                                                    </div>
                                                    <span>Green Area</span>
                                                </li>
                                                
                                            </ul>
                                            <div class="price-and-user">
                                                <p>Pricing per sq yrd <br/><span class="price"></span></p>
                                                {/* <a href="contact-us.html"><div class="default-btn-black-secondary">Inquire Now</div></a> */}
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-md-12">
                           
                        </div>
                        
                    </div>
                </div>

                <div class="tab-pane fade" id="Commerical" role="tabpanel">
                    <div class="row justify-content-center" data-cue="slideInUp">
                        <div class="col-xl-6 col-md-12">
                            <div class="properties-inner-card">
                                <div class="row justify-content-center">
                                    <div class="col-lg-5 col-md-6">
                                        <div class="properties-image bg-three ">
                                            
                                            <div class="media">
                                                <span><i class="ri-vidicon-fill"></i></span>
                                                <span><i class="ri-image-line"></i>5</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-7 col-md-6">
                                        <div class="properties-content">
                                            <div class="info">
                                                <ul class="link-list">
                                                    <li>
                                                        <span class="link-btn">the grand galleria </span>
                                                    </li>
                                                    <li>
                                                        <span class="link-btn">For Sale</span>
                                                    </li>
                                                </ul>
                                                
                                            </div>
                                            <div class="title">
                                                <h3>
                                                    <a href="">The Grand Galleria</a>
                                                </h3>
                                                <span>Jaipur - Ajmer Highway Expressway</span>
                                            </div>
                                            <ul class="info-list">
                                                <li>
                                                    <div class="icon">
                                                        <img src="/img/road-solid.svg" alt="Roads"/>
                                                    </div>
                                                    <span>120 ft Road</span>
                                                </li>
                                                <li>
                                                    <div class="icon">
                                                        <img src="/img/dungeon-solid.svg" alt="Roads"/>
                                                    </div>
                                                    <span>Prime Location</span>
                                                </li>
                                                <li>
                                                    <div class="icon">
                                                        <img src="/img/tree-solid.svg" alt="Roads"/>
                                                    </div>
                                                    <span>JDA Approved</span>
                                                </li>
                                                
                                            </ul>
                                            <div class="price-and-user">
                                                <p>Pricing <br/><span class="price"></span></p>
                                                {/* <a href="contact-us.html"><div class="default-btn-black-secondary">Inquire Now</div></a> */}
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    
                        <div class="col-xl-6 col-md-12">
                           
                        </div>
                        
                    </div>
                </div>




            </div>
            {/* <!-- properties cards end --> */}
        </div>
        </div>
    </div>
    {/* <!-- End Properties Wrap Area --> */}



    </div>
  )
}

export default Propertyarea